import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'

import SecondaryTitle from 'components/title_secondary/title_secondary'
import DragPicker from 'components/picker/drag/drag_picker'
import MediaSearch from 'decorators/media_search/media_search_decorator'
import VideoSearch from 'components/picker/search/video/video_picker_search'
import NearpodPickerBottomBar from '../../components/bottom_bar/nearpod_picker_bottom_bar'
import NearpodPickerOptions from '../../components/options/nearpod_picker_options'
import { normalizeVideoSearchFiles } from 'helpers/pickerNormalizer'
import { localize } from 'helpers/translator'

import styles from './nearpod_picker_video.scss'

class NearpodPickerVideo extends PureComponent {

	constructor() {
		super()
		this.cancelHandler = this.cancelHandler.bind(this)
		this.saveHandler = this.saveHandler.bind(this)
	}

	cancelHandler() {
		if (this.props.videoSearchActive) {
			this.props.onMediaSearchClear('video')
		} else {
			this.props.closeHandler()
		}
	}

	saveHandler() {
		const selectedItems = this.props.videoSearchResults.filter((data, index) => this.props.videoSearchSelected.includes(index))
		this.props.onFilesPicked(normalizeVideoSearchFiles(selectedItems, 'youtube'))
	}

	render() {
		return (
			<div styleName='wrapper'>
				<SecondaryTitle isCentered={true}>{localize('picker_video_title')}</SecondaryTitle>
				<VideoSearch
					onSearchConfirm={this.props.onMediaSearchConfirm}
					onSearchChange={this.props.onMediaSearchChange}
					onNextPageRequest={this.props.onMediaSearchNextPageRequest}
					onSearchSelection={this.props.onMediaSearchSelection}
					searchTextValue={this.props.videoSearchTextValue}
					results={this.props.videoSearchResults}
					active={this.props.videoSearchActive}
					selected={this.props.videoSearchSelected}
					showMore={this.props.videoShowMore}
					message={this.props.videoMessage}
					title={this.props.videoTitle}
					hint={this.props.videoHint}
					multiselect={this.props.multiselect}
					placeholder={localize('picker_search_youtube_video_placeholder')}
					source='youtube'
				/>
				{!this.props.videoSearchActive &&
				<div styleName='file-selection'>
					<div styleName='drag-and-drop'>
						<DragPicker
							onChange={this.props.onFilesPicked}
							accept={this.props.accept}
							pickerType={this.props.pickerType}
							dropRejectedHandler={this.props.onFileError}
							multiselect={this.props.multiselect} />
					</div>
					<span styleName='source-options-or'>{localize('picker_connector_or')}</span>
					<NearpodPickerOptions
						onFilesPicked={this.props.onFilesPicked}
						onFileError={this.props.onFileError}
						multiselect={this.props.multiselect}
						accept={this.props.accept}
						googleDrivePickerOrigin={this.props.googleDrivePickerOrigin}
					/>
				</div>}
				<NearpodPickerBottomBar
					cancelText={this.props.videoSearchActive?localize('global_back'):localize('global_cancel')}
					cancelHandler={this.cancelHandler}
					saveHandler={this.saveHandler}
					saveButtonEnabled={!!this.props.videoSearchSelected.length} />
			</div>
		)
	}
}

export default MediaSearch(CSSModules(NearpodPickerVideo, styles, {allowMultiple: true}))
